<template>
  <div class="page-wrapper rep-analytics-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="page-title split rep-analysis-title justify-content-between">
        <div class="">
        <h1 v-if="selectedGroupId" class="mb-0">Group Analytics</h1>
        <h1 v-else class="mb-0">Rep Analytics</h1>
        </div>
        <div class="rep-selector">
          <rep-selector />
        <div class="d-flex align-items-center gap-2 direct-grp">
          <label class="form-label mb-0 fit-content">Direct Group</label>
          <multiselect name="group" v-model="selectedGroupId" placeholder="Select Group"
            :options="groups.map((type) => type.group_id)"
            :custom-label="(opt) => groups.find((x) => x.group_id == opt).group_name" :options-limit="100"
            :internal-search="false" :local-search="false" @search-change="searchHandler" @open="getGroups" />
        </div>
        </div>
      </div>
      <br />
      <div class="direct">
        <div class="page-title">
          <h5 v-if="selectedGroupId">{{ groupAnalyticsTitle }} [ Direct Group ]</h5>
          <h5 v-else clas>Direct Analytics</h5>
        </div>
        <div class="row mb-3">
          <div class="col-md-12 col-lg-7">
            <NewMemberByMonth @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-md-12 col-lg-5">
            <div class="row">
              <OverallTotals @hide-loader="updateFlag" :groupId="selectedGroupId" />
            </div>
            <br />
            <div class="row">
              <OverallTotalMembers @hide-loader="updateFlag" :groupId="selectedGroupId" />
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-7">
            <EnrollmentsByMonth @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-md-5">
            <OverallTotalpolicies @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-12">
            <EnrollmentsTermsOverviewByYear @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
        </div>
        <div class="row mb-3 rep-analytics-third">
          <div class="col-md-7">
            <TotalMembersByIndividualPlan @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-md-5">
            <TotalActiveByState @hide-loader="updateFlag" :groupId="selectedGroupId" />
            <br />
            <TotalMembersByPlan @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
        </div>
      </div>
    </div>
    <!-- <member-plan-modal /> -->
  </div>
</template>
<script>
import OverallTotals from "./partials/OverallTotals.vue";
import OverallTotalMembers from "./partials/OverallTotalMembers.vue";
import NewMemberByMonth from "./partials/NewMemberByMonth.vue";
import EnrollmentsByMonth from "./partials/EnrollmentsByMonth.vue";
import OverallTotalpolicies from "./partials/OverallTotalpolicies.vue";
import EnrollmentsTermsOverviewByYear from "./partials/EnrollmentsTermsOverviewByYear.vue";
import TotalMembersByIndividualPlan from "./partials/TotalMembersByIndividualPlan.vue";
import TotalActiveByState from "./partials/TotalActiveByState.vue";
import TotalMembersByPlan from "./partials/TotalMembersByPlan.vue";
import RepSelector from "./RepSelector.vue";
import Api from "@/resource/Api";

export default {
  name: "RepAnalytics",
  components: {
    OverallTotals,
    OverallTotalMembers,
    NewMemberByMonth,
    EnrollmentsByMonth,
    OverallTotalpolicies,
    EnrollmentsTermsOverviewByYear,
    TotalMembersByIndividualPlan,
    TotalActiveByState,
    TotalMembersByPlan,
    RepSelector,
  },
  data() {
    return {
      repAnalytics: {
        enrollmentByMonth: false,
        enrollmentTermsOverviewByYear: false,
        newMemberByMonth: false,
        totalActiveByState: false,
        totalMembersByIndividualPlan: false,
        totalMembersByPlan: false,
        overallTotals: false,
        overallTotalPolicies: false,
        overallTotalMembers: false,
      },
      isLoading: true,
      loaderIcon: "",
      breadcrumbItems: [{ title: "Rep Analytics", active: true }],
      groups: null,
      selectedGroupId: ''
    };
  },
  computed: {
    groupAnalyticsTitle() {
      if (this.selectedGroupId) {
        const group = this.groups?.find(g => g.group_id === this.selectedGroupId);
        return group ? `${group.group_name} Analytics` : "Direct Analytics";
      }
      return "Direct Analytics";
    }
  },
  methods: {
    searchHandler(query) {
      if (query.length > 2) {
        this.getGroups(query);
      }
    },
    getGroups(query = "") {
      let url;
      if (query) {
        url = `v2/rep-analytics/group-list?&size=100&group_name=${query}`;
      } else {
        url = `v2/rep-analytics/group-list?&size=100`;
      }
      Api.get(url).then((res) => {
        this.groups = res.data.data;
      });
    },

    updateFlag(key) {
      // console.log("Emitted From", key);
      this.repAnalytics[key] = true;
      this.loadingStatus();
    },
    loadingStatus() {
      if (this.isLoading) {
        this.loaderIcon = this.$loading.show();
        this.isLoading = false;
      }
      let flags = Object.values(this.repAnalytics);
      if (flags.every((flag) => flag === true)) {
        this.loaderIcon.hide();
      }
    },
  },
  created() {
    this.loadingStatus();
    this.getGroups();

  },
  watch: {
    selectedGroupId(newVal, oldVal) {
      if (newVal !== oldVal) {
        Object.keys(this.repAnalytics).forEach(key => this.repAnalytics[key] = false);
        this.isLoading = true;
        this.loadingStatus();
      }
    }
  }

};
</script>
<style src="../../assets/css/repanalytics.css"></style>
